/**
 * Converts an array of objects into a CSV file and triggers a browser download.
 * @param {Array} data - The array of objects to export.
 * @param {string} filename - The desired name of the downloaded file.
 */
export const downloadCSV = (data, filename = 'export.csv') => {
  if (!data || !data.length) {
    console.warn("No data available to export");
    return;
  }

  // Extract headers from the first object's keys
  const headers = Object.keys(data[0]);

  // Map rows to CSV format, escaping commas and quotes
  const csvRows = data.map(row => 
    headers.map(header => {
      let cellValue = row[header] === null || row[header] === undefined ? '' : String(row[header]);
      // Escape double quotes and wrap in quotes if it contains a comma or newline
      if (cellValue.includes(',') || cellValue.includes('"') || cellValue.includes('\n')) {
        cellValue = `"${cellValue.replace(/"/g, '""')}"`;
      }
      return cellValue;
    }).join(',')
  );

  // Combine headers and rows
  const csvContent = [headers.join(','), ...csvRows].join('\n');

  // Create a Blob and trigger the download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
